import { isPresent } from 'utils'

export const OperationStatus = {
  // 광고계정
  OFF_BY_AD_ACCOUNT: {
    name: 'OFF_BY_AD_ACCOUNT',
    title: '광고계정 OFF',
    msg: '광고계정 상태가 OFF로 변경되어, 광고 노출이 일시 중지되었습니다.',
  },
  OFF_BY_AD_ACCOUNT_ADMIN_STOP: {
    name: 'OFF_BY_AD_ACCOUNT_ADMIN_STOP',
    title: '광고계정 관리자정지',
    msg: '광고계정이 관리자 정지되어, 광고를 운영할 수 없습니다.',
  },
  OFF_BY_AD_ACCOUNT_USER_BALANCE: {
    name: 'OFF_BY_AD_ACCOUNT_USER_BALANCE',
    title: '광고계정 잔액부족',
    msg: '광고계정이 잔액부족으로 캠페인을 운영할 수 없습니다.',
  },
  OFF_BY_NOT_CONNECTED_BIZ_WALLET: {
    name: 'OFF_BY_NOT_CONNECTED_BIZ_WALLET',
    title: '광고계정 비즈월렛 미연결',
    msg: '광고계정이 비즈월렛 미연결로 캠페인을 운영할 수 없습니다.',
  },

  // 비즈채널
  OFF_BY_BIZ_CHANNEL_ADMIN: {
    name: 'OFF_BY_BIZ_CHANNEL_ADMIN',
    title: '비즈채널 관리자정지',
    msg: '비즈채널이 관리자정지되어, 광고 노출이 일시 중지되었습니다.',
  },
  OFF_BY_BIZ_CHANNEL_APPROVING_OR_REJECTED: {
    name: 'OFF_BY_BIZ_CHANNEL_APPROVING_OR_REJECTED',
    title: '비즈채널 심사 미승인',
    msg: '비즈채널 심사가 완료되지 않았습니다.',
  },
  OFF_BY_BIZ_CHANNEL_TALK_CHANNEL_VIEW: {
    name: 'OFF_BY_BIZ_CHANNEL_TALK_CHANNEL_VIEW',
    title: '톡채널 조회불가',
    msg: '카카오톡 채널이 조회되지 않아, 광고 노출이 일시 중지되었습니다.',
  },

  // 캠페인(공통 + 광고계정)
  OFF_BY_CAMPAIGN_DAILY_BUDGET: {
    name: 'OFF_BY_CAMPAIGN_DAILY_BUDGET',
    title: '캠페인 일예산초과',
    msg: '캠페인 일예산 초과로 광고노출이 일시 중지되었습니다.',
    tiaraActionName: '필터_운영상태_운영불가(캠페인일예산초과)_클릭',
  },

  // 광고그룹(공통 + 캠페인 + 비즈채널)
  OFF_BY_AD_GROUP_DATE: {
    name: 'OFF_BY_AD_GROUP_DATE',
    title: '미노출 기간',
    msg: '광고그룹 집행 기간에 해당하지 않습니다.',
    tiaraActionName: '필터_운영상태_운영불가(미노출기간)_클릭',
  },
  OFF_BY_AD_GROUP_HOUR: {
    name: 'OFF_BY_AD_GROUP_HOUR',
    title: '미노출 시간',
    msg: '광고그룹 집행 시간에 해당하지 않습니다.',
    tiaraActionName: '필터_운영상태_운영불가(미노출시간)_클릭',
  },
  OFF_BY_AD_GROUP_DAY: {
    name: 'OFF_BY_AD_GROUP_DAY',
    title: '미노출 요일',
    msg: '광고그룹 집행 요일에 해당하지 않습니다.',
    tiaraActionName: '필터_운영상태_운영불가(미노출요일)_클릭',
  },
  OFF_BY_AD_GROUP_DAILY_BUDGET: {
    name: 'OFF_BY_AD_GROUP_DAILY_BUDGET',
    title: '광고그룹 일예산초과',
    msg: '광고그룹 일예산 초과로 광고노출이 일시 중지되었습니다.',
    tiaraActionName: '필터_운영상태_운영불가(광고그룹일예산초과)_클릭',
  },
  OFF_BY_CAMPAIGN: {
    name: 'OFF_BY_CAMPAIGN',
    title: '캠페인 OFF',
    msg: '캠페인 상태가 OFF로 변경되어, 광고 노출이 일시 중지되었습니다.',
  },

  // 키워드, 소재(공통 + 광고그룹 + 비즈채널)
  OFF_BY_AD_GROUP: {
    name: 'OFF_BY_AD_GROUP',
    title: '광고그룹 OFF',
    msg: '광고그룹 상태가 OFF로 변경되어, 광고 노출이 일시 중지되었습니다.',
    tiaraActionName: '필터_운영상태_운영불가(광고그룹OFF)_클릭',
  },

  // 공통
  ALL: {
    name: 'ALL',
    title: '전체',
    tiaraActionName: '필터_운영상태_전체_클릭',
  },
  ON: {
    name: 'ON',
    title: '운영 가능',
    tiaraActionName: '필터_운영상태_운영가능_클릭',
  },
  OFF: {
    name: 'OFF',
    title: 'OFF',
    msg: '상태가 OFF로 변경되어, 광고 노출이 일시 중지되었습니다.',
    tiaraActionName: '필터_운영상태_운영불가(OFF)_클릭',
  },
  DELETED: {
    name: 'DELETED',
    title: '삭제',
    tiaraActionName: '필터_운영상태_삭제_클릭',
  },
  APPROVING_OR_REJECTED: {
    name: 'APPROVING_OR_REJECTED',
    title: '심사 미승인',
    msg: '심사가 완료되지 않았습니다.',
    tiaraActionName: '필터_운영상태_운영불가(심사미승인)_클릭',
  },
}

/** @see https://wiki.daumkakao.com/pages/viewpage.action?pageId=606789954 */
export const OperationStatusInOrder = [
  // 공통
  OperationStatus.ALL,
  OperationStatus.ON,
  OperationStatus.DELETED,
  OperationStatus.OFF,

  // 비즈채널
  OperationStatus.OFF_BY_BIZ_CHANNEL_ADMIN,
  OperationStatus.OFF_BY_BIZ_CHANNEL_APPROVING_OR_REJECTED,
  OperationStatus.OFF_BY_BIZ_CHANNEL_TALK_CHANNEL_VIEW,

  // 심사
  OperationStatus.APPROVING_OR_REJECTED,

  // 광고그룹
  OperationStatus.OFF_BY_AD_GROUP,
  OperationStatus.OFF_BY_AD_GROUP_DAILY_BUDGET,
  OperationStatus.OFF_BY_AD_GROUP_DATE,
  OperationStatus.OFF_BY_AD_GROUP_HOUR,
  OperationStatus.OFF_BY_AD_GROUP_DAY,

  // 캠페인
  OperationStatus.OFF_BY_CAMPAIGN_DAILY_BUDGET,
  OperationStatus.OFF_BY_CAMPAIGN,

  // 계정
  OperationStatus.OFF_BY_AD_ACCOUNT_ADMIN_STOP,
  OperationStatus.OFF_BY_AD_ACCOUNT_USER_BALANCE,
  OperationStatus.OFF_BY_NOT_CONNECTED_BIZ_WALLET,
  OperationStatus.OFF_BY_AD_ACCOUNT,
]

export const ReviewStatus = {
  APPROVED: {
    name: 'APPROVED',
    title: '심사승인',
  },
  APPROVING: {
    name: 'APPROVING',
    title: '심사중',
  },
  LANDING_URL_APPROVING: {
    name: 'LANDING_URL_APPROVING',
    title: '심사중',
  },
  REJECTED_APPROVAL: {
    name: 'REJECTED_APPROVAL',
    title: '심사보류',
  },
}

export const getFinalKeywordReviewStatus = ({
  keywordReviewStatus,
  landingUrlReviewStatus,
  hasLandingUrl,
}) => {
  if (
    isPresent(landingUrlReviewStatus) &&
    keywordReviewStatus === ReviewStatus.APPROVED
  ) {
    if (!hasLandingUrl) return keywordReviewStatus
    return landingUrlReviewStatus === ReviewStatus.APPROVING
      ? ReviewStatus.LANDING_URL_APPROVING
      : landingUrlReviewStatus
  }
  return keywordReviewStatus
}

export const AssetCategories = {
  DEFAULT: {
    name: 'DEFAULT',
    title: '기본',
    tiaraActionName: '소재탭_필터_소재타입_기본_클릭',
  },
  EXTEND: {
    name: 'EXTEND',
    title: '확장전체',
    tiaraActionName: '소재탭_필터_소재타입_기본+확장전체_클릭',
  },
  IMAGE: {
    name: 'IMAGE',
    title: '이미지형',
    tiaraActionName: '소재탭_필터_소재타입_기본+확장이미지형_클릭',
  },
  TEXT: {
    name: 'TEXT',
    title: '텍스트형',
    tiaraActionName: '소재탭_필터_소재타입_기본+확장텍스트형_클릭',
  },
  BUTTON: {
    name: 'BUTTON',
    title: '버튼형',
    tiaraActionName: '소재탭_필터_소재타입_기본+버튼형_클릭',
  },
  LINK: {
    name: 'LINK',
    title: '연동형',
    tiaraActionName: '소재탭_필터_소재타입_기본+연동형_클릭',
  },
}

export const Assets = {
  THUMBNAIL: {
    name: 'THUMBNAIL',
    title: '썸네일',
  },
  MULTI_THUMBNAIL: {
    name: 'MULTI_THUMBNAIL',
    title: '멀티썸네일',
  },
  ADDITIONAL_TITLE: {
    name: 'ADDITIONAL_TITLE',
    title: '추가제목',
  },
  ADDITIONAL_LINK: {
    name: 'ADDITIONAL_LINK',
    title: '부가링크',
  },
  SUBJECT: {
    name: 'SUBJECT',
    title: '말머리',
  },
  PRICE_TABLE: {
    name: 'PRICE_TABLE',
    title: '가격테이블',
  },
  CALCULATE: {
    name: 'CALCULATE',
    title: '계산하기',
  },
  PHONE_NUMBER: {
    name: 'PHONE_NUMBER',
    title: '전화번호',
  },
  TALK_CHANNEL: {
    name: 'TALK_CHANNEL',
    title: '톡채널',
  },
  THUMBNAIL_RECOMMEND: {
    name: 'THUMBNAIL_RECOMMEND',
    title: '추천소재',
  },
  THUMBNAIL_CUSTOM: {
    name: 'THUMBNAIL_CUSTOM',
    title: '맞춤소재',
  },
}

export const ToastTypes = {
  SUCCESS: {
    containerClass: 'inner_tooltip_layer1',
    iconName: 'good',
    iconText: '완료',
  },
  FAIL: {
    containerClass: 'inner_tooltip_layer2',
    iconName: 'bad',
    iconText: '미완료',
  },
}

export const DeviceTypes = {
  PC: {
    name: 'PC',
    title: 'PC',
  },
  MOBILE: {
    name: 'MOBILE',
    title: '모바일',
  },
}

export const ChangeAmountUnit = {
  PERCENTAGE: 'PERCENTAGE',
  WON: 'WON',
}

export const MaxBiddingAmountChangeTypes = {
  INCREASE: 'INCREASE',
  DECREASE: 'DECREASE',
  NO_CALCULATE: 'NO_CALCULATE',
  RANK: 'RANK', // 순위별 입찰가를 프론트에서 구분하기 위해 사용, 서버로 전송할때는 NO_CALCULATE
}

export const BiddingStrategyTypes = {
  AUTOBIDDING_BY_RANK: 'AUTOBIDDING_BY_RANK',
  FIXBIDDING_BY_RANK: 'FIXBIDDING_BY_RANK',
  FIXBIDDING_BY_CUSTOM_MAX_BIDDING: 'FIXBIDDING_BY_CUSTOM_MAX_BIDDING',
  INHERIT_FROM_ADGROUP: 'INHERIT_FROM_ADGROUP',
}

export const ASSET_COMBINATIONS = {
  mobile: [
    [Assets.THUMBNAIL.name, Assets.PRICE_TABLE.name],
    [Assets.THUMBNAIL.name, Assets.ADDITIONAL_LINK.name],
    [Assets.THUMBNAIL.name, Assets.SUBJECT.name],
    [Assets.THUMBNAIL.name, Assets.ADDITIONAL_TITLE.name],
    [Assets.PRICE_TABLE.name, Assets.CALCULATE.name],
    [Assets.ADDITIONAL_LINK.name, Assets.CALCULATE.name],
    [Assets.SUBJECT.name, Assets.CALCULATE.name],
    [Assets.ADDITIONAL_TITLE.name, Assets.CALCULATE.name],
  ],
  pc: [
    [Assets.MULTI_THUMBNAIL.name, Assets.PRICE_TABLE.name],
    [Assets.MULTI_THUMBNAIL.name, Assets.ADDITIONAL_TITLE.name],
    [Assets.MULTI_THUMBNAIL.name, Assets.SUBJECT.name],
    [Assets.THUMBNAIL.name, Assets.PRICE_TABLE.name],
    [Assets.THUMBNAIL.name, Assets.ADDITIONAL_LINK.name],
    [Assets.THUMBNAIL.name, Assets.ADDITIONAL_TITLE.name],
    [Assets.THUMBNAIL.name, Assets.SUBJECT.name],
    [Assets.PRICE_TABLE.name, Assets.CALCULATE.name],
    [Assets.ADDITIONAL_LINK.name, Assets.CALCULATE.name],
    [Assets.SUBJECT.name, Assets.CALCULATE.name],
    [Assets.ADDITIONAL_TITLE.name, Assets.CALCULATE.name],
  ],
}

export const ReviewTargetType = {
  BIZCHANNEL: {
    name: 'BIZCHANNEL',
    title: '비즈채널',
  },
  CREATIVE: {
    name: 'CREATIVE',
    title: '소재',
  },
  KEYWORD: {
    name: 'KEYWORD',
    title: '키워드',
  },
  KEYWORD_LANDING_URL: {
    name: 'KEYWORD_LANDING_URL',
    title: '키워드 랜딩URL',
  },
}

export const Ranks = {
  MO1: {
    device: 'MOBILE',
    rank: 1,
  },
  MO2: {
    device: 'MOBILE',
    rank: 2,
  },
  MO3: {
    device: 'MOBILE',
    rank: 3,
  },
  MO4: {
    device: 'MOBILE',
    rank: 4,
  },
  MO5: {
    device: 'MOBILE',
    rank: 5,
  },
  MO6: {
    device: 'MOBILE',
    rank: 6,
  },
  PC1: {
    device: 'PC',
    rank: 1,
  },
  PC2: {
    device: 'PC',
    rank: 2,
  },
  PC3: {
    device: 'PC',
    rank: 3,
  },
  PC4: {
    device: 'PC',
    rank: 4,
  },
  PC5: {
    device: 'PC',
    rank: 5,
  },
  PC6: {
    device: 'PC',
    rank: 6,
  },
  PC7: {
    device: 'PC',
    rank: 7,
  },
  PC8: {
    device: 'PC',
    rank: 8,
  },
  PC9: {
    device: 'PC',
    rank: 9,
  },
  PC10: {
    device: 'PC',
    rank: 10,
  },
  PC11: {
    device: 'PC',
    rank: 11,
  },
  PC12: {
    device: 'PC',
    rank: 12,
  },
  PC13: {
    device: 'PC',
    rank: 13,
  },
  PC14: {
    device: 'PC',
    rank: 14,
  },
  PC15: {
    device: 'PC',
    rank: 15,
  },
}
export const getRankOptionText = (rankOption, isEdit = true) =>
  `${rankOption.device === 'MOBILE' ? '모바일' : rankOption.device} ${
    rankOption.rank
  }위 평균 입찰가로 ${isEdit ? '변경' : '입력'}`
export const getRankOptionSimpleText = rankOption =>
  `${rankOption.device === 'MOBILE' ? '모바일' : rankOption.device}${
    rankOption.rank
  }`
export const RankOptions = [
  Ranks.MO1,
  Ranks.MO2,
  Ranks.MO3,
  Ranks.MO4,
  Ranks.MO5,
  Ranks.MO6,
  Ranks.PC1,
  Ranks.PC2,
  Ranks.PC3,
  Ranks.PC4,
  Ranks.PC5,
  Ranks.PC6,
  Ranks.PC7,
  Ranks.PC8,
  Ranks.PC9,
  Ranks.PC10,
  Ranks.PC11,
  Ranks.PC12,
  Ranks.PC13,
  Ranks.PC14,
  Ranks.PC15,
]
export const DashboardTypes = {
  CAMPAIGN: 'campaign',
  AD_GROUP: 'adGroup',
  KEYWORD: 'keyword',
  CREATIVE: 'creative',
}
export const DashboardTypeDTOs = {
  [DashboardTypes.CAMPAIGN]: 'campaigns',
  [DashboardTypes.AD_GROUP]: 'adGroupDtos',
  [DashboardTypes.KEYWORD]: 'keywordDtos',
  [DashboardTypes.CREATIVE]: 'creativeLinkDtos',
}
export const DashboardInfoTypes = {
  AD_ACCOUNT: 'adAccount',
  CAMPAIGN: 'campaign',
  AD_GROUP: 'adGroup',
  KEYWORD: 'keyword',
  CREATIVE: 'creative',
  TOTAL_CAMPAIGN: 'totalCampaign',
  TOTAL_AD_GROUP: 'totalAdGroup',
  TOTAL_KEYWORD: 'totalKeyword',
  TOTAL_CONTENT_MATCHING: 'totalContentMatching',
  TOTAL_CREATIVE: 'totalCreative',
}
export const DashboardInfoTypeNames = {
  [DashboardInfoTypes.AD_ACCOUNT]: '광고계정',
  [DashboardInfoTypes.CAMPAIGN]: '캠페인',
  [DashboardInfoTypes.AD_GROUP]: '광고그룹',
  [DashboardInfoTypes.KEYWORD]: '키워드',
  [DashboardInfoTypes.CREATIVE]: '소재',
  [DashboardInfoTypes.TOTAL_CAMPAIGN]: '전체 캠페인',
  [DashboardInfoTypes.TOTAL_AD_GROUP]: '전체 광고그룹',
  [DashboardInfoTypes.TOTAL_KEYWORD]: '전체 키워드',
  [DashboardInfoTypes.TOTAL_CONTENT_MATCHING]: '콘텐츠 매체',
  [DashboardInfoTypes.TOTAL_CREATIVE]: '전체 소재',
}
export const BizChannelTypes = {
  WEBSITE_BIZ_CHANNEL: 'WEBSITE_BIZ_CHANNEL',
  TALK_CHANNEL: 'TALK_CHANNEL',
}
export const BizChannelTypeNames = {
  [BizChannelTypes.WEBSITE_BIZ_CHANNEL]: '웹사이트',
  [BizChannelTypes.TALK_CHANNEL]: '카카오톡 채널',
}

export const CampaignTypes = {
  PREMIUM_LINK: 'PREMIUM_LINK',
  TALK_CHANNEL: 'TALK_CHANNEL',
}
export const CampaignTypeNames = {
  [CampaignTypes.PREMIUM_LINK]: '프리미엄링크',
  [CampaignTypes.TALK_CHANNEL]: '톡채널검색',
}
export const CampaignTypeBizChannelTypeMap = {
  [CampaignTypes.PREMIUM_LINK]: BizChannelTypes.WEBSITE_BIZ_CHANNEL,
  [CampaignTypes.TALK_CHANNEL]: BizChannelTypes.TALK_CHANNEL,
}

export const TalkChannelFontColors = {
  BLACK: 'BLACK',
  WHITE: 'WHITE',
}

export const FontColorNames = {
  [TalkChannelFontColors.BLACK]: '검은색',
  [TalkChannelFontColors.WHITE]: '흰색',
}

export const CreativeTypes = {
  BASIC: 'BASIC',
  TALK_CHANNEL: 'TALK_CHANNEL',
}

export const BIZ_CHANNEL_TALK_CHANNEL_SEARCHABLE = {
  ON: '채널 검색 허용',
  OFF: '채널 검색 비허용',
  UNKNOWN: '알 수 없음',
}
export const BIZ_CHANNEL_TALK_CHANNEL_STATUS = {
  ACTIVATED: '채널 공개',
  DEACTIVATED: '채널 비공개',
  DELETING: '채널 삭제중',
  DELETED: '채널 삭제완료',
}
